<button pButton type="button" class="atlas-btn atlas-btn-primary tall" type="button" (click)="addEmail()"
  title="{{ 'common.add' | translate | titlecase }}">
  {{ 'common.add' | translate | titlecase }}
</button>
<div *ngFor="let emailAddress of value; index as i">
  <div class="grid cols-1fr-5fr-collapse items-start gap-10px">
    <div class="flex column">
      <div>{{ 'common.type' | translate | titlecase }}</div>
      <select [(ngModel)]="emailAddress.EmailAddressTypeID" class="form-control" required>
        <option>{{ 'common.select' | translate | titlecase }}</option>
        <option *ngFor="let addressType of emailAddressTypes" [value]="addressType.EmailAddressTypeID">{{
          addressType.Name }}</option>
      </select>
    </div>
    <div class="flex column">
      <div>{{ 'common.personal-information.email-address' | translate | titlecase }}</div>
      <input type="email" class="form-control" [(ngModel)]="emailAddress.EmailAddress" wlTrimInput />
    </div>
    <div class="flex row-collapse items-end w-100">
      <button pButton type="button" class="atlas-btn atlas-btn-danger tall" type="button"
        (click)="deleteEmailAddress(i)" title="{{ 'common.delete' | translate | titlecase }}">
        {{ 'common.delete' | translate | titlecase }}
      </button>
    </div>
  </div>
</div>